import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RouterModule } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AuthFirebaseService } from './domain/usecase/firebase/auth-firebase-use-case';
import { SeguridadUseCase } from './domain/usecase/seguridad/seguridad-use-case';
import { UsuarioService } from './shared/services/usuario.service';
import { SharedModule } from './shared/shared.module';


@Component({
    selector: 'app-root',
    imports: [SharedModule, RouterModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private readonly _destroyRef = inject(DestroyRef);

    collapsed = signal(false);

    toggleSidebar() {
        this.collapsed.set(!this.collapsed());
    }

    sidenavWidth = computed(() => this.collapsed() ? '63px' : '260px');
    public urlSeusCerrarSesion = '';
    public nombreUsuario = '';


    constructor(
        private readonly usuarioService: UsuarioService,
        protected localStorage: StorageMap,
        private readonly _seguridadUseCase: SeguridadUseCase,
        private readonly _authFirebaseService: AuthFirebaseService,
    ) {

    }

    ngOnInit() {
        /*const usuarioQuemado = new Usuario(
            true,
            'SALUD_DOMICILIARIA',
            'luzevamo',
            'Usuario de Prueba',
            '12345678',
            'REPO_PRUEBAS',
            'usuario.prueba@sura.com.co',
            'Usuario creado para pruebas'
        );

        this.usuarioService.InfoUsuario = usuarioQuemado;*/

        this.cargarSeus();
    }

    private cargarSeus() {
        this.cargarLogin();
        this.cargarUrlLogout();
    }

    private cargarLogin() {
        this._seguridadUseCase.checkLogin()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe({
                next: () => this.cargarDatosUsuarioLogueado(),
            });
    }

    private cargarUrlLogout() {
        this._seguridadUseCase.cerrarSesion()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe({
                next: (value) => {
                    this.urlSeusCerrarSesion = value;
                    sessionStorage.setItem('urlSeusCerrar', value);
                },
            });
    }

    private cargarDatosUsuarioLogueado() {
        this._seguridadUseCase.datosUsuarioLogueado()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe({
                next: (value) => {
                    this.usuarioService.InfoUsuario = value;
                    this.nombreUsuario = value.fullName;
                    this.inicializarFirebase();
                },
            });
    }

    private inicializarFirebase() {
        this._authFirebaseService.signIn()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe({
                error: (err) => console.error('[Firebase] Error al obtener token o autenticar:', err),
            });
    }

    cerrarSesion() {
        if (this.urlSeusCerrarSesion !== '') {
            window.location.href = this.urlSeusCerrarSesion;
        }
    }
}
